import { render, staticRenderFns } from "./SlideRunningShipment.vue?vue&type=template&id=0cc6a5eb"
import script from "./SlideRunningShipment.vue?vue&type=script&lang=js"
export * from "./SlideRunningShipment.vue?vue&type=script&lang=js"
import style0 from "./SlideRunningShipment.vue?vue&type=style&index=0&id=0cc6a5eb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports